/* ==== MM / Slider Vidéo + Stories — JS ===================================
   Piste : carrousel Splide monté par SplideManager (mm_components.js) —
   drag, molette, carte active centrée et départ sur la 3e carte en mobile
   sont natifs (data-splide de la section). Ce script gère la preview vidéo
   et la visionneuse.
   Clic sur une carte → visionneuse plein écran type stories Instagram :
   segments de progression, play/pause, prev/next, Esc pour fermer.
   Chaque carte fournit : img (poster), .mm-vcard__author, et en option
   data-video (url mp4) et data-duration (secondes, défaut 8).          */
   (function () {
	'use strict';
  
	/* Icônes du SET, en miroir exact du rendu de mm-icon (standard §2/§3 —
	   jamais redessinées) : tracés copiés depuis assets/Icons/ (icon-play,
	   icon-pause, icon-back, icon-chevron-right, icon-close). icon_class
	   'icon-play'/'icon-pause' : le CSS d'états du play/pause s'appuie dessus. */
	var SVG_PLAY = '<svg class="mm-flex icon-play" style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.45294 4.26845C5.25296 4.14994 5 4.29408 5 4.52653V11.4735C5 11.706 5.25296 11.8501 5.45294 11.7316L11.3145 8.25814C11.5105 8.14194 11.5105 7.85814 11.3145 7.74194L5.45294 4.26845Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	var SVG_PAUSE = '<svg class="mm-flex icon-pause" style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="4.5" y="4" width="2" height="8" rx="0.5" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="9.5" y="4" width="2" height="8" rx="0.5" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	var SVG_CHEVRON_L = '<svg style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	var SVG_CHEVRON_R = '<svg style="width: 16px; height: 16px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	var SVG_CLOSE = '<svg style="width: 14px; height: 14px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.5 4.5L4.5 11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M4.5 4.5L11.5 11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
  
	function formatTime(seconds) {
	  var m = Math.floor(seconds / 60);
	  var s = Math.floor(seconds % 60);
	  return m + ':' + String(s).padStart(2, '0') + ' s';
	}
  
	/* ------------------------------------------------ visionneuse ------- */
	function createStory(items) {
	  var strings = window.accessibilityStrings || {};
	  var story = document.createElement('div');
	  story.className = 'mm-story';
	  story.setAttribute('role', 'dialog');
	  story.setAttribute('aria-modal', 'true');
	  story.setAttribute('aria-label', strings.videoStories || '');
	  story.innerHTML =
		'<div class="mm-story__overlay"></div>' +
		'<button type="button" class="mm-story__close" aria-label="' + (strings.close || '') + '">' + SVG_CLOSE + '</button>' +
		'<button type="button" class="mm-story__nav mm-story__nav--prev" aria-label="' + (strings.videoPrevious || '') + '">' + SVG_CHEVRON_L + '</button>' +
		'<div class="mm-story__card">' +
		'  <div class="mm-story__media"></div>' +
		'  <div class="mm-story__progress">' +
		items.map(function () { return '<div class="mm-story__seg"><span></span></div>'; }).join('') +
		'  </div>' +
		'  <div class="mm-story__author"></div>' +
		'  <div class="mm-story__controls">' +
		'    <button type="button" class="mm-story__playpause" aria-label="' + (strings.videoPlayPause || '') + '">' + SVG_PAUSE + SVG_PLAY + '</button>' +
		'    <div class="mm-story__seek"><span></span></div>' +
		'    <span class="mm-story__time"></span>' +
		'  </div>' +
		'</div>' +
		'<button type="button" class="mm-story__nav mm-story__nav--next" aria-label="' + (strings.videoNext || '') + '">' + SVG_CHEVRON_R + '</button>';
	  document.body.appendChild(story);
  
	  var media = story.querySelector('.mm-story__media');
	  var author = story.querySelector('.mm-story__author');
	  var segs = story.querySelectorAll('.mm-story__seg');
	  var seek = story.querySelector('.mm-story__seek span');
	  var time = story.querySelector('.mm-story__time');
	  var current = 0;
	  var activeVideo = null;

	  /* barre de lecture + minuteur calés sur la position RÉELLE de la vidéo
	     (pas d'auto-avance sur durée fixe : une vidéo joue jusqu'à sa fin) */
	  function onTimeUpdate() {
		var v = activeVideo;
		if (!v || !v.duration) return;
		var ratio = v.currentTime / v.duration;
		seek.style.transform = 'scaleX(' + ratio + ')';
		if (segs[current]) segs[current].firstElementChild.style.transform = 'scaleX(' + ratio + ')';
		time.textContent = formatTime(Math.max(0, Math.ceil(v.duration - v.currentTime)));
	  }

	  function setItem(index) {
		current = (index + items.length) % items.length;
		var item = items[current];

		story.classList.remove('is-paused');

		/* média */
		if (activeVideo) {
		  activeVideo.removeEventListener('timeupdate', onTimeUpdate);
		  activeVideo.removeEventListener('ended', next);
		  activeVideo = null;
		}
		if (item.video) {
		  media.innerHTML = '<video src="' + item.video + '" poster="' + (item.poster || '') + '" playsinline autoplay></video>';
		  activeVideo = media.querySelector('video');
		  activeVideo.addEventListener('timeupdate', onTimeUpdate);
		  activeVideo.addEventListener('ended', next);
		} else {
		  media.innerHTML = '<img src="' + item.poster + '" alt="">';
		}

		/* auteur */
		author.innerHTML =
		  (item.avatar ? '<img src="' + item.avatar + '" alt="">' : '') +
		  '<span><strong>' + item.author + '</strong><span>' + item.caption + '</span></span>';

		time.textContent = '';

		/* segments : done (avant) / à venir — la progression du segment actif
		   est pilotée par onTimeUpdate, pas par une animation CSS */
		segs.forEach(function (seg, i) {
		  seg.classList.remove('is-active', 'is-done');
		  seg.firstElementChild.style.transform = i < current ? 'scaleX(1)' : 'scaleX(0)';
		  if (i < current) seg.classList.add('is-done');
		});
		if (segs[current]) segs[current].classList.add('is-active');
		seek.style.transform = 'scaleX(0)';
	  }

	  function next() { setItem(current + 1); }
	  function prev() { setItem(current - 1); }

	  var returnFocus = null;

	  function open(index) {
		returnFocus = document.activeElement;
		story.classList.add('is-open');
		document.documentElement.style.overflow = 'hidden';
		setItem(index);
		story.querySelector('.mm-story__close').focus();
	  }
	  function close() {
		story.classList.remove('is-open', 'is-paused');
		if (activeVideo) {
		  activeVideo.removeEventListener('timeupdate', onTimeUpdate);
		  activeVideo.removeEventListener('ended', next);
		  activeVideo = null;
		}
		media.innerHTML = '';
		document.documentElement.style.overflow = '';
		if (returnFocus && returnFocus.focus) returnFocus.focus();
		returnFocus = null;
	  }

	  function togglePause() {
		story.classList.toggle('is-paused');
		if (activeVideo) story.classList.contains('is-paused') ? activeVideo.pause() : activeVideo.play();
	  }

	  story.querySelector('.mm-story__overlay').addEventListener('click', close);
	  story.querySelector('.mm-story__close').addEventListener('click', close);
	  story.querySelector('.mm-story__nav--prev').addEventListener('click', prev);
	  story.querySelector('.mm-story__nav--next').addEventListener('click', next);
	  story.querySelector('.mm-story__playpause').addEventListener('click', togglePause);
	  /* tap sur la vidéo = play/pause, comme sur les stories */
	  media.addEventListener('click', togglePause);
  
	  document.addEventListener('keydown', function (e) {
		if (!story.classList.contains('is-open')) return;
		if (e.key === 'Escape') close();
		if (e.key === 'ArrowRight') next();
		if (e.key === 'ArrowLeft') prev();
		if (e.key === ' ' && !e.target.closest('button')) { e.preventDefault(); togglePause(); }
		if (e.key === 'Tab') {
		  var focusables = Array.prototype.filter.call(story.querySelectorAll('button'), function (b) { return b.getClientRects().length > 0; });
		  if (!focusables.length) return;
		  var first = focusables[0];
		  var last = focusables[focusables.length - 1];
		  if (!story.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
		  else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
		  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
		}
	  });
  
	  return { open: open };
	}
  
	/* --------------------------------------- preview au survol / actif -- */
	/* Chaque carte avec data-video reçoit une <video> muette en boucle,
	   créée à la volée. Desktop : lecture au survol. Mobile / tactile :
	   lecture sur la carte centrée (active). Le poster reste dessous. */
	function createPreviews(cards) {
	  function ensureVideo(card) {
		var src = card.getAttribute('data-video');
		if (!src) return null;
		var video = card.querySelector('.mm-vcard__video');
		if (!video) {
		  video = document.createElement('video');
		  video.className = 'mm-vcard__video';
		  video.muted = true;
		  video.loop = true;
		  video.playsInline = true;
		  video.setAttribute('muted', '');
		  video.setAttribute('playsinline', '');
		  video.setAttribute('preload', 'none');
		  video.setAttribute('tabindex', '-1');
		  video.setAttribute('aria-hidden', 'true');
		  var poster = card.querySelector(':scope > img');
		  if (poster && poster.nextSibling) card.insertBefore(video, poster.nextSibling);
		  else card.appendChild(video);
		}
		if (!video.getAttribute('src')) video.setAttribute('src', src);
		return video;
	  }
  
	  function start(card) {
		var video = ensureVideo(card);
		if (!video) return;
		card.classList.add('is-previewing');
		var p = video.play();
		if (p && p.catch) p.catch(function () {});
	  }
	  function stop(card) {
		card.classList.remove('is-previewing');
		var video = card.querySelector('.mm-vcard__video');
		if (video) { video.pause(); try { video.currentTime = 0; } catch (e) {} }
	  }
	  function stopAll() { cards.forEach(stop); }
  
	  return { start: start, stop: stop, stopAll: stopAll };
	}
  
	/* ------------------------------------------------ slider ------------ */
	/* Viewer stories partagé (31/07) : les Stories vidéo du product form
	   réutilisent EXACTEMENT ce viewer (window.MmStoryViewer, consommé par
	   assets/mm-video-stories.js) — exposé comme window.MmMotion l'est,
	   plutôt que dupliqué (standard : élément répété = snippet/partagé) */
	window.MmStoryViewer = window.MmStoryViewer || { create: createStory };
  
	function initVSlider(root) {
	  /* les previews ré-exécutent les scripts : init une seule fois par racine */
	  if (root.hasAttribute('data-mm-vslider-ready')) return;
	  root.setAttribute('data-mm-vslider-ready', '');
	  var slider = root.querySelector('.mm-vslider__slider');

	  /* La piste d'avis (aucune .mm-vcard) s'arrête là : pas de preview
	     vidéo, pas de visionneuse Stories, juste le carrousel Splide. */
	  var cards = Array.prototype.slice.call(root.querySelectorAll('.mm-vcard'));
	  if (!cards.length) return;

	  var previews = createPreviews(cards);
	  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  
	  /* données stories depuis les cartes */
	  var items = cards.map(function (card) {
		var img = card.querySelector(':scope > img');
		var avatar = card.querySelector('.mm-vcard__author img');
		return {
		  poster: img ? img.src : '',
		  video: card.getAttribute('data-video') || null,
		  duration: parseInt(card.getAttribute('data-duration'), 10) || 8,
		  author: (card.querySelector('.mm-vcard__author strong') || {}).textContent || '',
		  caption: (card.querySelector('.mm-vcard__author span span') || {}).textContent || '',
		  avatar: avatar ? avatar.src : null
		};
	  });
	  var story = createStory(items);
  
	  cards.forEach(function (card, i) {
		card.addEventListener('click', function () {
		  previews.stopAll();       /* pas de preview derrière la visionneuse */
		  story.open(i);
		});
	  });
  
	  /* preview : survol en desktop, carte centrée en tactile */
	  if (canHover) {
		cards.forEach(function (card) {
		  card.addEventListener('mouseenter', function () { previews.start(card); });
		  card.addEventListener('mouseleave', function () { previews.stop(card); });
		});
	  } else {
		/* carte centrée = slide active Splide (focus center). L'instance est
		   montée par SplideManager à l'approche du slider (IntersectionObserver) :
		   on attend son signal si elle n'existe pas encore. */
		var inView = false;
		var splide = null;
		function updatePreview() {
		  if (!inView || !splide) return;
		  var active = splide.Components.Slides.getAt(splide.index);
		  var best = active && active.slide.querySelector('.mm-vcard');
		  cards.forEach(function (card) {
			if (card === best) previews.start(card);
			else previews.stop(card);
		  });
		}
		function bindSplide() {
		  if (splide || !slider || !slider._splide) return;
		  splide = slider._splide;
		  splide.on('moved', updatePreview);
		  updatePreview();
		}
		bindSplide();
		document.addEventListener('global:splide-initialized', bindSplide);
		/* la carte centrée démarre dès que le slider est visible */
		var ioPrev = new IntersectionObserver(function (entries) {
		  inView = entries[0].isIntersecting;
		  if (inView) updatePreview();
		  else previews.stopAll();
		}, { threshold: 0.4 });
		ioPrev.observe(root);
	  }
	}
	document.querySelectorAll('.mm-vslider').forEach(initVSlider);
  })();